import { Component, DestroyRef, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { StoreConfig, StoreConfigService } from '@scalefast/config-angular';
import { CartProduct, Product, createCartProductFromProduct } from '@scalefast/core';
import { AddToCartService } from '@scalefast/ecommerce-core';
import { EMPTY } from 'rxjs';
import { catchError, take } from 'rxjs/operators';
import { AppAddToCartTemplateComponent } from './add-to-cart-template/add-to-cart-template.component';

@Component({
  selector: 'app-add-to-cart',
  template: `<app-add-to-cart-template
    [cartProduct]="cartProduct"
    [productId]="cartProduct?.productId"
    [productTitle]="productTitle"
    [productDescription]="productDescription"
    [includeQuantitySelector]="includeQuantitySelector"
    [loading]="loading"
    [small]="small"
    (addToCart)="onAddToCart($event)"
    (resetAddToCartButton)="onResetButton($event)"
  />`,
  standalone: true,
  imports: [AppAddToCartTemplateComponent],
})
export class AppAddToCartComponent implements OnChanges {
  @Input() product: Product | undefined;
  @Input() includeQuantitySelector = false;
  @Input() loading = false;
  @Input() productTitle = '';
  @Input() small = false;
  @Output() addedToCartEvent = new EventEmitter<number>();
  cartProduct: CartProduct | undefined;
  private storeConfig: StoreConfig;

  MAX_ITEM_QUANTITY: number;

  constructor(
    private addToCartService: AddToCartService,
    private destroyRef: DestroyRef,
    private storeConfigService: StoreConfigService,
  ) {
    this.storeConfig = this.storeConfigService.get();
    this.MAX_ITEM_QUANTITY = this.storeConfig.maxItemQuantity;
  }

  ngOnChanges(): void {
    this.getProduct();
  }

  get productDescription(): string {
    if (!this.product) {
      return '';
    }

    return this.addToCartService.getProductDescription(this.product);
  }

  onResetButton(status: boolean): void {
    this.loading = this.addToCartService.onResetButton(status);
  }

  onAddToCart(cartProduct: CartProduct): void {
    if (this.product) {
      cartProduct.productId = this.product.id;
    }

    this.loading = true;

    // This overide the cartproduct and set the quantity to the correct value, this should not be done by refenrence,
    // instead the subscription should return the correct value
    this.addToCartService
      .onAddToCart(cartProduct)
      .pipe(
        catchError((err) => {
          console.log(err);
          return EMPTY;
        }),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe((cartObj) => {
        this.loading = false;
        // This should be the correct way to get the quantity, and not cahing the object by reference on the service
        // const currentCartProduct = cartObj.cart.products.find((product) => product.productId === cartProduct.productId);
        if (cartObj.errorCode === 1) {
          this.addedToCartEvent.emit(cartProduct.quantity);
        } else {
          this.addedToCartEvent.emit(cartObj.errorCode);
        }
      });
  }

  private getProduct(): void {
    if (this.product?.id) {
      this.addToCartService
        .getProduct$(this.product.id)
        .pipe(take(1), takeUntilDestroyed(this.destroyRef))
        .subscribe((product: Product) => {
          if (product) {
            this.cartProduct = createCartProductFromProduct(product);
          }
        });
    }
  }
}
